var _defs, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIceaHeader = function SvgIceaHeader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 75.82 49.93",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsheader{fill:#fff;}"))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icea-header")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M71.21.33c-.15-.09-.55.22-1,.53l-.85.48a25.41,25.41,0,0,0-2.91,2.07,4.28,4.28,0,0,1,.44.2,26.84,26.84,0,0,1,2.58-2.14c4.93,3,9.43,8.21,9.74,14,.29,5.44-3.73,10.56-8.19,13.79a24.2,24.2,0,0,1-4.64-3.69,17.12,17.12,0,0,0-1.87,1,25.74,25.74,0,0,0,4.83,3.81c.17.1,1.59-.86,1.79-1,5-3,9.61-8.24,9.91-14.12.33-6.16-4.8-11.88-9.87-14.94",
    transform: "translate(-33.7 -0.31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M67.26,5.66a4,4,0,0,1-2.08.46c-.53,0-1.62-1.44-4.52-.66a5.83,5.83,0,0,1,6.6.2",
    transform: "translate(-33.7 -0.31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M66.64,9.84s2.54,3.4-4.61,7.38-3.45,9.59-3.45,9.59-.44-4.89,5.18-7.19,5.59-8.21,2.88-9.78",
    transform: "translate(-33.7 -0.31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M69.37,7.28c-.1,0,2.87.35,5.18,4.76a4.7,4.7,0,0,0-5.18-4.76",
    transform: "translate(-33.7 -0.31)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M68.92,7.61a10.75,10.75,0,0,1,6.38,8.58A11.09,11.09,0,0,1,72.09,22s3.07-8.69-3.68-14Z",
    transform: "translate(-33.7 -0.31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M67.26,9.18S67,9,67.87,8.41c0,0,6,4.37,2,14.42a16.92,16.92,0,0,0-9.31,4.9s-.48-3.76,4.75-7.19,5.08-7.89,1.9-11.36",
    transform: "translate(-33.7 -0.31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M59.09,13.55a2.75,2.75,0,0,1-1.82-.48A1.9,1.9,0,0,1,56.66,12l.42-.45-.62,0a2.55,2.55,0,0,1-.2-.76c0-.22.88-.42,1.84-.95s1.44-.76,1.62-1.3.09-.73,1.51-1S64,6.41,65.42,6.76c0,0,2.51-.16,3.15-1.18,0,0,.5,1.41-1.38,2.35,0,0-1.44,1-1.18,1.78a4.1,4.1,0,0,1,0,2.75c-.35,1.48-2.12,1-3.52,1.86s-.59,1.5-.59,1.5-1.26.53-2,.11a.86.86,0,0,1,.15-1.57c.64-.31,1.94-1,1.94-1a3.07,3.07,0,0,0-1.72-.09c-.65.3-1,1-1.62,1.35-1,.48-1.5-.59-2.18-.44a2.27,2.27,0,0,0-.88.38,1.14,1.14,0,0,1,1.18-1c1,0,1.67,1,2.26-.07m1.35-3.63c.26-.72,1.83-1.27,1.83-1.27L60,9.14Z",
    transform: "translate(-33.7 -0.31)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "clsheader",
    x: 44.46,
    y: 27.2,
    width: 31.22,
    height: 0.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "clsheader",
    x: 1.68,
    y: 27.2,
    width: 20.82,
    height: 0.26
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M36.73,41.12h-3a1.17,1.17,0,0,0,.45-1V31.7a1.17,1.17,0,0,0-.45-1h3a1.08,1.08,0,0,0-.48,1v8.47a1,1,0,0,0,.46.94",
    transform: "translate(-33.7 -0.31)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M48.07,39.07a4.27,4.27,0,0,1-.41,1.75,7.73,7.73,0,0,1-3.39.61A5.9,5.9,0,0,1,40.16,40a4.87,4.87,0,0,1-1.61-3.81,5.59,5.59,0,0,1,1.55-4,6,6,0,0,1,4.56-1.76,10.63,10.63,0,0,1,2.85.37l.23,2a4,4,0,0,0-1.33-1,4.15,4.15,0,0,0-1.74-.39c-2.54,0-3.81,1.46-3.81,4.41a5.25,5.25,0,0,0,.9,3.1,3.54,3.54,0,0,0,3.12,1.58A3.91,3.91,0,0,0,48,38.65a1.83,1.83,0,0,1,.06.42",
    transform: "translate(-33.7 -0.31)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M57,39.66l-.18,1.46H49.05a1.2,1.2,0,0,0,.46-1V31.75a1.15,1.15,0,0,0-.48-1h7.24l.17,1.16A3.72,3.72,0,0,0,55,31.7H51.63v3.46c.66,0,1.31,0,1.95,0A15.72,15.72,0,0,0,55.52,35l.2,1.31a3,3,0,0,0-1.47-.25H51.63V40a11.74,11.74,0,0,0,1.84.09c1,0,1.59,0,1.84,0A3.8,3.8,0,0,0,57,39.66",
    transform: "translate(-33.7 -0.31)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M69,41.12h-3a.33.33,0,0,0,.24-.32,1,1,0,0,0-.13-.42L65,37.78a20.68,20.68,0,0,0-2.11-.07c-.84,0-1.55,0-2.14.07l-1,2.32a2.23,2.23,0,0,0-.22.69.38.38,0,0,0,.22.33h-2a1.87,1.87,0,0,0,.72-.92l3.47-8.28a2.31,2.31,0,0,0,.2-.65.75.75,0,0,0-.11-.33.44.44,0,0,0-.32-.22H64l4.18,9.46c.26.51.5.85.78.94M64.57,36.8l-1.75-4-1.68,4c.5,0,1,.06,1.68.06s1.27,0,1.75-.06",
    transform: "translate(-33.7 -0.31)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M81.31,39.64,81,41.12H73.2a1.2,1.2,0,0,0,.46-1V31.73a1.18,1.18,0,0,0-.48-1h3.06a1.11,1.11,0,0,0-.48,1v8.34c.5,0,1.06.07,1.68.07a10.42,10.42,0,0,0,3.87-.5",
    transform: "translate(-33.7 -0.31)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M85.54,41.12h-3a1.19,1.19,0,0,0,.44-1V31.7a1.15,1.15,0,0,0-.46-1h3a1.06,1.06,0,0,0-.48,1v8.47a1.12,1.12,0,0,0,.5.94",
    transform: "translate(-33.7 -0.31)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M98.46,35.83a5.23,5.23,0,0,1-1.71,4,6.17,6.17,0,0,1-4.37,1.59A5.64,5.64,0,0,1,88.3,40a5.22,5.22,0,0,1-1.55-3.91A5.33,5.33,0,0,1,88.47,32a6.19,6.19,0,0,1,4.37-1.56,5.57,5.57,0,0,1,4.08,1.49,5.15,5.15,0,0,1,1.54,3.95m-2.26.75a6.59,6.59,0,0,0-.85-3.39,3.21,3.21,0,0,0-2.92-1.81,3,3,0,0,0-2.56,1.26,4.48,4.48,0,0,0-.81,2.72,6.19,6.19,0,0,0,.88,3.32,3.22,3.22,0,0,0,2.9,1.74,3,3,0,0,0,2.51-1.22,4.1,4.1,0,0,0,.85-2.62",
    transform: "translate(-33.7 -0.31)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M109.53,30.72a.91.91,0,0,0-.48.9V41.1h-.87l-7.08-8v7.07a1,1,0,0,0,.48.92H99.4a1.11,1.11,0,0,0,.47-.94V31.71a1.17,1.17,0,0,0-.47-1h2.09l6.32,7.15V31.57a1,1,0,0,0-.46-.85Z",
    transform: "translate(-33.7 -0.31)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M55.19,47.77h0a2.44,2.44,0,0,1,2.48-2.5,2.61,2.61,0,0,1,1.85.64l-.37.41a2.18,2.18,0,0,0-1.51-.56,1.9,1.9,0,0,0-1.88,2v0a1.89,1.89,0,0,0,2,2,2.55,2.55,0,0,0,1.44-.48V48.07H57.66v-.5h2v1.92a3,3,0,0,1-2,.74,2.37,2.37,0,0,1-2.52-2.46",
    transform: "translate(-33.7 -0.31)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M63,45.34h2.14a2.09,2.09,0,0,1,1.42.48,1.31,1.31,0,0,1,.38.94v0a1.44,1.44,0,0,1-1.34,1.4l1.53,2H66.4L65,48.27H63.54v1.88H63V45.34ZM65,47.81c.74,0,1.27-.37,1.27-1v0c0-.59-.46-1-1.27-1H63.5v1.95H65Z",
    transform: "translate(-33.7 -0.31)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M69.55,47.77h0a2.48,2.48,0,0,1,2.53-2.5,2.44,2.44,0,0,1,2.52,2.47v0a2.48,2.48,0,0,1-2.54,2.49,2.45,2.45,0,0,1-2.51-2.48m4.48,0h0a2,2,0,0,0-2-2,1.93,1.93,0,0,0-1.94,2v0a1.95,1.95,0,1,0,3.89,0",
    transform: "translate(-33.7 -0.31)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M77.57,48.14v-2.8h.55v2.77a1.42,1.42,0,0,0,1.52,1.62,1.4,1.4,0,0,0,1.49-1.59v-2.8h.55v2.77a2.06,2.06,0,1,1-4.11,0",
    transform: "translate(-33.7 -0.31)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "clsheader",
    d: "M85.15,45.34H87c1.13,0,1.87.59,1.87,1.53v0c0,1-.89,1.59-1.94,1.59h-1.2v1.69h-.55V45.34ZM86.94,48c.81,0,1.36-.43,1.36-1.07v0c0-.68-.53-1-1.32-1H85.72v2.12h1.22Z",
    transform: "translate(-33.7 -0.31)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIceaHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icea-header.e7b95f70.svg";
export { ForwardRef as ReactComponent };